import { render, staticRenderFns } from "./ReceptionAccessories.vue?vue&type=template&id=5cb0cb61&scoped=true"
import script from "./ReceptionAccessories.vue?vue&type=script&lang=js"
export * from "./ReceptionAccessories.vue?vue&type=script&lang=js"
import style0 from "./ReceptionAccessories.vue?vue&type=style&index=0&id=5cb0cb61&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb0cb61",
  null
  
)

export default component.exports